import type { EnvRecord } from '@imobdesk/env'

/** Maps Vite `import.meta.env` (VITE_* in .env) to canonical keys for @imobdesk/env. */
export function getImobdeskEnvRecord(): EnvRecord {
  return {
    IMOBDESK_API_URL: import.meta.env.VITE_IMOBDESK_API_URL,
    LOGIN_APP_URL: import.meta.env.VITE_LOGIN_APP_URL,
    MAIN_APP_URL: import.meta.env.VITE_MAIN_APP_URL,
    SUPORTE_APP_URL: import.meta.env.VITE_SUPORTE_APP_URL,
  }
}
